var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.13089C9.15253 3.13089 7.86025 3.63436 6.90744 4.53055C5.95464 5.42674 5.41935 6.64223 5.41935 7.90963C5.41935 9.17703 5.95464 10.3925 6.90744 11.2887C7.86025 12.1849 9.15253 12.6884 10.5 12.6884C11.8475 12.6884 13.1398 12.1849 14.0926 11.2887C15.0454 10.3925 15.5806 9.17703 15.5806 7.90963C15.5806 6.64223 15.0454 5.42674 14.0926 4.53055C13.1398 3.63436 11.8475 3.13089 10.5 3.13089ZM5.08065 15.237C3.73317 15.237 2.44089 15.7405 1.48809 16.6367C0.535281 17.5329 0 18.7484 0 20.0158V21.5297C0 22.4905 0.739742 23.3086 1.74774 23.4628C7.54374 24.3536 13.4563 24.3536 19.2523 23.4628C19.7397 23.3874 20.183 23.1517 20.503 22.7977C20.8231 22.4437 20.9992 21.9944 21 21.5297V20.0158C21 18.7484 20.4647 17.5329 19.5119 16.6367C18.5591 15.7405 17.2668 15.237 15.9194 15.237H15.4587C15.2058 15.2379 14.9601 15.2744 14.7217 15.3466L13.5484 15.7073C11.5676 16.3155 9.43243 16.3155 7.45161 15.7073L6.27832 15.3466C6.04051 15.2749 5.79239 15.2379 5.54264 15.237H5.08065Z",
    fill: "#FEC200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.f0f74653c11644199af3451035094d9b.svg";
export { ForwardRef as ReactComponent };